/////////////////////////////////////////////////////////////////////////////
import { CollectionGroupItem } from '@/app/shared/components';
import { CollectionsGroup } from '@/core/interfaces';

interface CollectionsGridProps {
	groups: CollectionsGroup[];
}

export const GroupsGrid: React.FC<CollectionsGridProps> = ({ groups }) => {
	/*********************
	// #region Template
	**********************/
	return (
		<div className="grid grid-cols-2 max-w-xl mx-auto gap-3 pb-32">
			{groups.map((group: CollectionsGroup) => {
				return <CollectionGroupItem key={group.name} group={group} />;
			})}
		</div>
	);
};
